import { ExecutionDetailResponseBody, TenantType } from '@lct-jobs/core';

export const isReleaseStageExecution = (execution?: ExecutionDetailResponseBody): boolean =>
  execution?.tenantType === TenantType.RELEASE_STAGE;
